import { makeRequestWithErrorReporting } from './request'
import Configs from 'infrastructure/config/environment'

export const ProdApiRoute = 'https://api.kiddom.co'

function apiUrl(apiPath: string) {
  const path = apiPath.startsWith('/') ? apiPath.slice(1) : apiPath
  return `${Configs().ApiUrl}/${path}`
}

function makeKiddomRequestForUrl<T>({
  url,
  method,
  optionOverrides,
}: {
  url: string
  method: string
  optionOverrides?: RequestInit
}) {
  return makeRequestWithErrorReporting<T>({
    url,
    method,
    optionOverrides: {
      headers: new Headers({ Accept: 'application/json' }),
      ...optionOverrides,
      credentials: 'include',
    },
  })
}

function makeKiddomRequestForPath<T>({
  path,
  method,
  optionOverrides,
}: {
  path: string
  method: string
  optionOverrides?: RequestInit
}) {
  return makeKiddomRequestForUrl<T>({
    url: apiUrl(path),
    method,
    optionOverrides,
  })
}

export function makeKiddomGetRequest<T>({
  kiddomPath,
}: {
  kiddomPath: string
}) {
  return makeKiddomRequestForPath<T>({ path: kiddomPath, method: 'GET' })
}

export function makeKiddomPutRequest<T>({
  kiddomPath,
  requestBody,
}: {
  kiddomPath: string
  requestBody: object | unknown[]
}) {
  return makeKiddomRequestForPath<T>({
    path: kiddomPath,
    method: 'PUT',
    optionOverrides: {
      body: JSON.stringify(requestBody),
    },
  })
}

export function makeKiddomPatchRequest<T>({
  kiddomPath,
  requestBody,
}: {
  kiddomPath: string
  requestBody: Record<string, unknown> | unknown[] | object
}) {
  return makeKiddomRequestForPath<T>({
    path: kiddomPath,
    method: 'PATCH',
    optionOverrides: {
      body: JSON.stringify(requestBody),
    },
  })
}

export function makeKiddomPostRequest<T>({
  kiddomPath,
  requestBody,
}: {
  kiddomPath: string
  requestBody: object
}) {
  return makeKiddomRequestForPath<T>({
    path: kiddomPath,
    method: 'POST',
    optionOverrides: {
      body: JSON.stringify(requestBody),
    },
  })
}

export function makeKiddomMultipartPostRequest<T>({
  kiddomPath,
  formData,
}: {
  kiddomPath: string
  formData: FormData
}) {
  return makeKiddomRequestForPath<T>({
    path: kiddomPath,
    method: 'POST',
    optionOverrides: {
      body: formData,
    },
  })
}

export function makeKiddomDeleteRequest<T>({
  kiddomPath,
  requestBody = {},
}: {
  kiddomPath: string
  requestBody?: object
}) {
  return makeKiddomRequestForPath<T>({
    path: kiddomPath,
    method: 'DELETE',
    optionOverrides: { body: JSON.stringify(requestBody) },
  })
}

export function makeKiddomProdGetRequest<T>({
  prodPath,
}: {
  prodPath: string
}) {
  const path = prodPath.startsWith('/') ? prodPath.slice(1) : prodPath
  return makeKiddomRequestForUrl<T>({
    url: `${ProdApiRoute}/${path}`,
    method: 'GET',
  })
}
